/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2022. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */ /*
 * Licensed Materials - Property of IBM
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'FARSResult_Title',
    defaultMessage: 'Verify Your Identity - Results',
  },
  successMessage: {
    id: 'FARSResult_Success',
    defaultMessage: 'You have successfully completed the verification process.',
  },
  next: {
    id: 'FARSResult_Next',
    defaultMessage: 'Next',
  },
});
